import antdJa from "antd/lib/locale-provider/ja_JP";
import jaMessages from "../locales/ja_JP.json";

const JaLang = {
  messages: {
    ...jaMessages,
  },
  antd: antdJa,
  locale: "ja",
};
export default JaLang;
